import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ToastProvider } from './components/Toast';
import './App.css';

const StartPage = lazy(() => import('./pages/StartPage'));
const ViewerPage = lazy(() => import('./pages/ViewerPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));

function LoadingFallback() {
  return (
    <div className="loading-container">
      <div className="loading-spinner" />
      <p>Loading...</p>
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <div className="app">
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/viewer/:rsvDashboardId" element={<ViewerPage />} />
            <Route path="/dashboard/:rsvDashboardId" element={<DashboardPage />} />
          </Routes>
        </Suspense>
      </div>
    </ToastProvider>
  );
}

export default App;
